import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ email: "", password: "" });

  const onSubmit = (e) => {
    e.preventDefault();
    if (!form.email.includes("@") || form.password.length < 6) {
      toast.error("Please enter a valid email and password (6+ chars).");
      return;
    }
    toast.info("Demo: login flow not connected. Try our 14-day free trial!");
  };

  return (
    <div data-testid="login-page" className="min-h-[calc(100vh-5rem)] grid lg:grid-cols-2">
      <div className="hidden lg:block relative bg-[#12b571] overflow-hidden">
        <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-[#52B788]/30 blur-3xl" />
        <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-[#FFE4E8]/10 blur-3xl" />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-xl bg-[#E8F5E9] flex items-center justify-center">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M4 6h12a4 4 0 010 8H4V6z" stroke="#12b571" strokeWidth="2.5" strokeLinejoin="round"/>
                <path d="M4 14h14a4 4 0 010 8H4v-8z" stroke="#12b571" strokeWidth="2.5" strokeLinejoin="round"/>
              </svg>
            </div>
            <span className="font-display font-extrabold text-2xl">Brivo</span>
          </Link>
          <div>
            <h2 className="font-display text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight">
              "Brivo replaced 4 separate tools we were paying for. Sales jumped 32% in two months."
            </h2>
            <div className="mt-8 flex items-center gap-3">
              <img src="https://images.unsplash.com/photo-1758887261865-a2b89c0f7ac5?crop=entropy&cs=srgb&fm=jpg&q=85&w=200" alt="" className="w-12 h-12 rounded-full object-cover" />
              <div>
                <div className="font-semibold">Adaeze Okonkwo</div>
                <div className="text-sm text-white/60">Founder, Lush Boutique</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 lg:p-16 bg-[#FFFCF2]">
        <div className="w-full max-w-md">
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-black tracking-tight">Welcome back</h1>
          <p className="mt-3 text-black/70">Log in to your Brivo dashboard.</p>

          <form onSubmit={onSubmit} className="mt-10 space-y-4">
            <div>
              <label className="text-sm font-semibold text-black mb-2 block">Email</label>
              <input
                data-testid="login-email"
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full px-4 py-3 rounded-xl border border-[#12b571]/15 focus:border-[#12b571] focus:outline-none transition-colors bg-white"
                placeholder="you@business.com"
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-black mb-2 block flex justify-between">
                <span>Password</span>
                <a href="#" className="text-xs font-medium text-black/60 hover:text-black">Forgot?</a>
              </label>
              <div className="relative">
                <input
                  data-testid="login-password"
                  type={show ? "text" : "password"}
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  className="w-full px-4 py-3 rounded-xl border border-[#12b571]/15 focus:border-[#12b571] focus:outline-none transition-colors bg-white pr-12"
                  placeholder="••••••••"
                />
                <button type="button" onClick={() => setShow(!show)} className="absolute right-4 top-1/2 -translate-y-1/2 text-black/50">
                  {show ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            {/* <button data-testid="login-submit" type="submit" className="btn-primary w-full justify-center mt-2">
              Log in <ArrowRight size={18} />
            </button> */}
          </form>

          <div className="mt-6 text-sm text-center text-black/70">
            New to Brivo? <Link to="https://brivopos.com" className="font-semibold text-black hover:underline">Start free trial</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
